import React from "react";

const RightSideModalInChatting = ({ modalClose, children }) => {
    return (
        <div className="hiclasstv-modal right-side chatting" onClick={() => modalClose({ selectedFunc: "NONE" })}>
            {children}
        </div>
    );
}

export default RightSideModalInChatting;